<template>
  <div class="content">
    <div>
      <Form :model="formInline" inline :label-width="60">
        <FormItem :label="$t('设备ID')">
          <Input v-model="formInline.did" :placeholder="$t('请输入')"> </Input>
        </FormItem>
        <FormItem :label="$t('状态')">
          <Select v-model="formInline.is_deal" style="width: 200px">
            <Option :value="0">{{ $t("全部") }}</Option>
            <Option :value="1">{{ $t("未处理") }}</Option>
            <Option :value="2">{{ $t("已处理") }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit" class="btn">{{
            $t("查询")
          }}</Button>
          <Button type="error" @click="handleReset">{{ $t("重置") }}</Button>
        </FormItem>
      </Form>
    </div>
    <div class="tableContent">
      <Table :columns="tableColumns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <Button
            v-if="row.is_deal == $t('未处理')"
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="show(row)"
            >{{ $t("处理") }}</Button
          >
        </template>
      </Table>
    </div>
    <div class="pageContent">
      <Page
        :total="total"
        size="small"
        show-elevator
        show-sizer
        show-total
        @on-change="handlePageChange"
        :current="page"
        :page-size="page_size"
      />
    </div>
    <Modal v-model="modalBl" :title="$t('密码设置')">
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem :label="$t('密码')" prop="pwd">
          <Input v-model="formValidate.pwd" :placeholder="$t('请输入')"></Input>
        </FormItem>
        <FormItem :label="$t('有效时长')" prop="city">
          <Select v-model="formValidate.city" :placeholder="$t('请选择')">
            <Option value="1800">{{ $t("30分钟") }}</Option>
            <Option value="3600">{{ $t("1小时") }}</Option>
            <Option value="7200">{{ $t("2小时") }}</Option>
            <Option value="10800">{{ $t("3小时") }}</Option>
            <Option value="21600">{{ $t("6小时") }}</Option>
            <Option value="43200">{{ $t("12小时") }}</Option>
            <Option value="86400">{{ $t("24小时") }}</Option>
            <Option value="172800">{{ $t("48小时") }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('使用次数')" prop="use_num">
          <Input
            v-model="formValidate.use_num"
            :placeholder="$t('请输入')"
          ></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmitModal('formValidate')">{{
            $t("确定")
          }}</Button>
          <Button
            @click="handleResetModal('formValidate')"
            style="margin-left: 8px"
            >{{ $t("取消") }}</Button
          >
        </FormItem>
      </Form>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { getinfoData, editinfoData } from "@/api/chuku"; // 确保这个路径是正确的
import crypto from "crypto"; // 引入 crypto 模块

export default {
  data() {
    return {
      formInline: {
        did: "",
        is_deal:null,
      },
      formValidate: {
        pwd: "",
        city: "",
        use_num: "",
      },
      page: 1,
      page_size: 10,
      total: 0,
      ruleValidate: {
        pwd: [
          {
            required: true,
            message: this.$t("请输入"),
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: this.$t("请选择"),
            trigger: "change",
          },
        ],
        // use_num: [
        //   {
        //     required: true,
        //     message: this.$t("请输入"),
        //     trigger: "blur",
        //   },
        // ],
      },
      tableColumns: [
        {
          title: this.$t("设备ID"),
          key: "did",
        },
        {
          title: this.$t("申请原因"),
          key: "reason",
        },
        {
          title: this.$t("申请时间"),
          key: "apply_time",
        },
        {
          title: this.$t("状态"),
          key: "is_deal",
        },
        {
          title: this.$t("失效时间"),
          key: "end_time",
        },
        {
          title: this.$t("可用次数"),
          key: "total_num",
        },
        {
          title: this.$t("操作"),
          slot: "action",
          width: 150,
          align: "center",
        },
      ],
      tableData: [],
      modalBl: false,
    };
  },
  methods: {
    handleSubmit() {
      this.getDataInfo(this.page, this.page_size);
    },
    handleReset() {
      this.formInline.did = "";
      this.formInline.is_deal = null;
      this.getDataInfo(this.page, this.page_size);
    },
    show(row) {
      this.modalBl = true;
      console.log(row);
      this.formValidate = row;
    },
    handleSubmitModal(name) {
      console.log(this.formValidate);
      this.$refs[name].validate((valid) => {
        if (valid) {
          let client_id = "I2LrdEvgYleFT6srGHBjmA4DfX1Yl7Hc";
          let client_secret = "c5G89q8bKPOSak5KDZd1RHLh6KSsjaD1";
          let req_time = Math.floor(Date.now() / 1000);
          let new_timestamp = req_time + Number(this.formValidate.city);
          let md5Hash = this.generateMD5(client_secret, req_time);
          let params = {
            client_id: client_id,
            req_time: req_time,
            start_time: req_time,
            end_time: new_timestamp,
            client_signkey: md5Hash,
            total_num: Number(this.formValidate.use_num),
            pwd_id: this.formValidate.pwd_id,
            status: 1,
            pwd:this.formValidate.pwd
          };
          editinfoData(params).then((res) => {
            if (res.result == 0) {
              this.modalBl = false;
              this.$Message.success("设置成功");
              this.getDataInfo(this.page, this.page_size);
            } else {
              this.$Message.success("设置失败");
            }
          });
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    handleResetModal(name) {
      this.$refs[name].resetFields();
      this.modalBl = false;
    },
    handlePageChange(page) {
      console.log(page);
      this.getDataInfo(page, this.page_size);
    },
    generateMD5(clientSecret, reqTime) {
      return crypto
        .createHash("md5")
        .update(clientSecret + reqTime)
        .digest("hex");
    },
         getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    },
    getDataInfo(page, page_size) {
      let client_id = "I2LrdEvgYleFT6srGHBjmA4DfX1Yl7Hc";
      let client_secret = "c5G89q8bKPOSak5KDZd1RHLh6KSsjaD1";
      let req_time = Math.floor(Date.now() / 1000);
      let md5Hash = this.generateMD5(client_secret, req_time);
const token = this.getCookie('token');console.log(token);

      let params = {
        client_id: client_id,
        req_time: req_time,
        client_signkey: md5Hash,
        page: page,
        page_size: page_size,
        did: this.formInline.did,
        is_deal: this.formInline.is_deal,
        access_token:token
      };

      getinfoData(params).then((res) => {
        console.log(res);
        this.tableData = [];
        // 转换时间戳
        this.total = res.body.total;
        this.tableData = res.body.items.map((item) => {
          return {
            ...item,
            apply_time: this.formatTimestamp(item.apply_time),
            end_time:
              item.end_time !== 0
                ? this.formatTimestamp(item.end_time)
                : item.end_time,
            is_deal: item.is_deal == 1 ? this.$t("未处理") : this.$t("已处理"),
          };
        });
      });
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleString();
    },
  },
  mounted() {
    this.getDataInfo(this.page, this.page_size);
  },
};
</script>

<style scoped>
.content {
  background: white;
  height: 100%;
  padding: 16px;
}
.btn {
  margin-right: 15px;
}
.tableContent {
  margin-top: 36px;
}
.pageContent {
  text-align: center;
  margin-top: 10px;
}
</style>
